import { createReactBlockSpec } from "@blocknote/react";
import { useContext, useState } from "react";
import type { BlockAppointmentFields } from "schemas";
import { BlocksContext } from "../../BlocksContext";
import { AppointmentCard } from "../../components/AppointmentCard";

export const AppointmentLinkBlockSpec = createReactBlockSpec(
  {
    type: "appointmentLinkBlock",
    propSchema: {
      appointmentId: {
        default: "",
      },
      label: {
        default: "",
      },
      header: {
        default: "",
      },
      description: {
        default: "",
      },
      image: {
        default: "",
      },
      url: {
        default: "",
      },
      tags: {
        default: "",
      },
      buttonBackgroundColor: {
        default: "",
      },
      buttonTextColor: {
        default: "",
      },
    },
    content: "none", // No editable content needed
    isSelectable: true,
  },
  {
    render: ({
      editor,
      block: {
        id,
        props: { appointmentId, label, header, description, image, url, tags, buttonBackgroundColor, buttonTextColor },
      },
    }) => {
      const { SelectAppointmentDrawer } = useContext(BlocksContext);
      const [showDrawer, setShowDrawer] = useState(!appointmentId);

      const handleCloseDrawer = () => {
        // If the user closes the drawer without selecting an appointment,
        // remove the empty block
        if (!appointmentId) {
          editor.removeBlocks([id]);
        }
        setShowDrawer(false);
      };

      const handleAppointmentSelected = (props: BlockAppointmentFields) => {
        // Update the block with the selected appointmentId
        editor.updateBlock(id, { props: props });
        editor.setTextCursorPosition(id);
        setShowDrawer(false);
      };

      // If appointment ID is empty, show the drawer to select an appointment
      if (showDrawer) {
        return (
          <SelectAppointmentDrawer onClose={handleCloseDrawer} onAppointmentSelected={handleAppointmentSelected} />
        );
      }

      return (
        <AppointmentCard
          buttonBackgroundColor={buttonBackgroundColor}
          buttonTextColor={buttonTextColor}
          label={label}
          header={header}
          href={url}
          description={description}
          image={image}
          tags={JSON.parse(tags)}
        />
      );
    },
  },
);
